// ======================================================================
// File Name       : CustomLink
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getIcon } from '../../utils/PageUtils';

class CustomLink extends Component {

  render() {
    const {
      className,
      icon,
      text,
      to,
      onClick,
    } = this.props;
    return (
      <Link
        className={`${className} text-decoration-none`}
        to={{ pathname: to }}
        onClick={onClick}
      >
        {icon && (getIcon(icon))}
        {text}
      </Link>
    );
  }
}
export default CustomLink;
